module.exports = __webpack_public_path__ + "personalcollege.jpg?ce980f7a25e0ce185bb276d38b16e8e0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/personalcollege.jpg
// module id = 145
// module chunks = 0